'use es6';
'use es6';

import { createSelector } from 'reselect';
import { getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
export const getCanMABExperiment = createSelector([getIsBlogListingPage], isBlogListingPage => {
  return !isBlogListingPage;
});